import React from 'react';
import styles from 'assets/css/Button.module.css';
import { IconRefresh } from '@ace/react-icons';
import useUTag from 'tracking/useUTag';
import { useQueryClient } from 'react-query';
import { CardLinkIconWrap } from 'Components/Card/CardLink';

export default function RefreshLink(props) {
    const componentName = props.componentName;
    const linkText = props.linkText || "";
    
    const queryClient = useQueryClient();
    const { linkEvent } = useUTag();

    return (
        <a className={`${styles.floating} ${props.className}`} href={`#${componentName}`} onClick={() => linkEvent({ event: "refresh-link-click" }, () => queryClient.invalidateQueries(componentName))} >
            <CardLinkIconWrap>
                <IconRefresh fill="#e53d46" />
            </CardLinkIconWrap>
            {linkText}
        </a>
    );
}
